exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-run-model-content>div:not(first-child){margin-top:10px}.cvat-run-model-content-remove-mapping-icon{color:#ff4136}\n", ""]);
